export const SYSTEM_CONFIGURATION = 'SYSTEM_CONFIGURATION';
export const COMMUNITY_SETTINGS = 'COMMUNITY_SETTINGS';
export const NS_SETTINGS = 'NS_SETTINGS';
